import React, { useEffect, useState } from "react";
import QuickAddTab from "./tabs/QuickAddTab";
import BulkUpdateTab from "./tabs/BulkUpdateTab";
import PurchaseInvoiceTab from "./tabs/PurchaseInvoiceTab";

function StockUpdateModal({
  isOpen,
  mode: initialMode = "quick",
  initialItem,
  defaultLocationId,
  onClose,
  onSuccess,
  onOpenPIPage,
}) {
  const [mode, setMode] = useState(initialMode);

  useEffect(() => {
    if (isOpen) setMode(initialMode);
  }, [isOpen, initialMode]);

  const handleSuccess = (result) => {
    onSuccess?.(result);
    onClose?.();
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <>
      {isOpen && (
        <div
          className="modal fade show standard-modal"
          id="standard-modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="standard-modalLabel"          
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-success text-white">
                <div className="d-flex align-items-center gap-2">
                  <div>
                    <h4 className="modal-title fw-bold mb-0 text-white">
                      <i className="ti ti-package me-2" />
                      Update Stock
                    </h4>
                    <small>Choose how you want to update inventory</small>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={handleClose}
                />
              </div>
              <div className="modal-body">
                <ul className="nav nav-tabs pb-3 mb-0" role="tablist">
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link ${mode === "quick" ? "active" : ""}`}
                      onClick={() => setMode("quick")}
                    >
                      <i className="ti ti-plus me-1" />
                      Quick Add
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link ${mode === "bulk" ? "active" : ""}`}
                      onClick={() => setMode("bulk")}
                    >
                      <i className="ti ti-list me-1" />
                      Bulk Update
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link ${mode === "pi" ? "active" : ""}`}
                      onClick={() => setMode("pi")}
                    >
                      <i className="ti ti-file-invoice me-1" />
                      Purchase Invoice
                    </button>
                  </li>
                </ul>

                {mode === "quick" && (
                  <QuickAddTab
                    initialItem={initialItem}
                    defaultLocationId={defaultLocationId}
                    onSuccess={handleSuccess}
                  />
                )}
                {mode === "bulk" && (
                  <BulkUpdateTab
                    defaultLocationId={defaultLocationId}
                    onSuccess={handleSuccess}
                  />
                )}
                {mode === "pi" && (
                  <PurchaseInvoiceTab
                    defaultLocationId={defaultLocationId}
                    onSuccess={handleSuccess}
                    onOpenFullPage={() => {
                      onClose?.();
                      onOpenPIPage?.();
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default StockUpdateModal;
